<template>
  <b-modal
    size="xl"
    scrollable
    content-class="projectDetailModal"
    v-model="isShow"
  >
    <template #modal-title>
      {{ $t('Sample Project Detail') }}
    </template>
    <b-container fluid>
      <ProjectDetail :project="project" />
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="float-right">
        <b-button size="sm" @click="ok">
          {{ $t('Close') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ProjectDetail from '@/components/popup/ProjectDetail.vue'
import { mapState } from 'vuex'

export default {
  name: 'ProjectDetailPopup',
  components: {
    ProjectDetail
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState(['project', 'projectDetailPopupData'])
  },
  watch: {
    projectDetailPopupData() {
      if (this.projectDetailPopupData.isShow) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style scoped>
.container-fluid {
  padding-right: 10px;
  padding-left: 10px;
  text-align: center;
}

.container-fluid > * {
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .projectDetailModal .modal-body {
    padding: 1rem 0;
  }
  .container-fluid {
    padding-left: 3px;
    padding-right: 3px;
  }
}

@media only screen and (max-width: 1199px) {
  .modal-xl {
    max-width: 96%;
  }
}
</style>
